<template>
  <div class="col-12">
    <div class="d-flex flex-md-column">
      <section id="desc">
        <div
          class="d-flex flex-column flex-md-row about-wrap align-items-center"
        >
          <div class="about-text text-justify second">
            <p>
              MOE Scholarship Program for Overseas Study in Arts and Design
              (SPOSAD) is an elite cultivation project held in Taiwan since
              2005. One of its goals is to breed young students in the field of
              design industry. Through serial public selection, the program
              hopes to discover talented young students, and provide them with
              the opportunity of a 1-year academic and practical training in its
              overseas partner institutes, which are well-known for their
              accomplishment in arts and design.
            </p>
          </div>
          <div
            class="about-img d-none d-md-block"
            :style="{ backgroundImage: `url(${intro})` }"
          ></div>
        </div>

        <div
          class="n-mx-rem1 mt-5 d-sm-none mobile-divider"
          style="width: 100vw"
        >
          <img :src="divider" alt="" class="w-100" />
        </div>
      </section>
    </div>
    <!-- <section id="gruop-intro" class="mt-5">
      <div class="mobile-h3 d-md-none text-center mb-2 mt-3">各組特色</div>
      <div
        class="
          d-flex
          flex-column flex-md-row
          about-wrap
          align-items-center
          n-mx-rem11
        "
      >
        <div
          class="about-img"
          :style="{
            backgroundImage: `url(${groupImage[$route.params.groupId[5] - 1]})`,
          }"
        ></div>

        <div class="about-text text-justify first px-4 pe-sm-0">
          <div class="title mb-2">
            {{ groups[$route.params.groupId[5] - 1] }}
          </div>

          {{ groupIntro[$route.params.groupId[5] - 1] }}
        </div>
      </div>
    </section> -->

    <!-- <div class="n-mx-rem1 mt-5 d-md-none mobile-divider">
      <img :src="divider" alt="" class="w-100" />
    </div> -->

    <!-- <div class="mobile-h3 d-md-none text-center mb-2 mt-3">Selection Process and Important Timing</div> -->
    <section id="schedule" class="mb-4 mt-5">
      <div
        class="accordion-title mobile-h3 text-center text-md-start mb-3 w-100"
      >
        Selection Process
      </div>
      <div class="small-text schedule-wrap">
        <div class="d-flex">
          <div class="schedule-phase d-flex flex-column">
            <div class="phase-title old-small-bold d-flex">
              New program approved <br />by Ministry of Education, Taiwan
            </div>
            <div class="phase-content">
              <div class="date old-small">Feb</div>
            </div>
          </div>
          <div class="schedule-phase d-flex flex-column">
            <div class="phase-title old-small-bold d-flex">
              Open for application
            </div>
            <div class="phase-content">
              <div class="date old-small">March - May</div>
            </div>
          </div>
          <div class="schedule-phase d-flex flex-column">
            <div class="phase-title old-small-bold d-flex">
              Domestic selection of top 30 students <br />into summer workshop
            </div>
            <div class="phase-content">
              <div class="date old-small">June</div>
            </div>
          </div>
          <div class="schedule-phase d-flex flex-column">
            <div class="phase-title old-small-bold d-flex">Summer workshop</div>
            <div class="phase-content">
              <div class="date old-small">July</div>
            </div>
          </div>
          <div class="schedule-phase d-flex flex-column">
            <div class="phase-title old-small-bold d-flex">
              Domestic selection of 4 candidates <br />among the top 30 students
            </div>
            <div class="phase-content">
              <div class="date old-small">December</div>
            </div>
          </div>
          <div class="schedule-phase d-flex flex-column">
            <div class="phase-title old-small-bold d-flex">
              Scholarship winner <br />chosen by the partner institutes
            </div>
            <div class="phase-content">
              <div class="date old-small">January – April (next year)</div>
            </div>
          </div>
          <div class="schedule-phase d-flex flex-column">
            <div class="phase-title old-small-bold d-flex">Study Abroad</div>
            <div class="phase-content">
              <div class="date old-small">September (next year)</div>
            </div>
          </div>
        </div>
      </div>
      <div class="arrows text-end d-flex justify-content-end">
        <button class="flex-center scroll-btn scroll-left">
          <img :src="arrowLeft" alt="" />
        </button>
        <button class="flex-center scroll-btn scroll-right">
          <img :src="arrowRight" alt="" />
        </button>
      </div>
    </section>
    <!-- accordions -->
    <section id="registration-info" class="mt-0">
      <div
        class="
          d-flex
          justify-content-between
          reg-accordion
          flex-wrap flex-md-nowrap flex-md-nowrap
        "
      >
        <div class="accordion-title mobile-body flex-shrink-0">
          Domestic Selection
        </div>
        <div class="order-4 order-md-2" id="collapse1">
          <div class="p-2 pt-0 small-text text-justify">
            The committee will review applicants’ school works and
            documentation. Applicants who submit their registration forms will
            also be required to provide documents, such as their portfolios,
            autobiography, study plan, certificate and awards, which serve as an
            evidence of their professional ability. The domestic committee will
            choose top 30 students into summer workshop.
          </div>
        </div>
      </div>
      <div
        class="
          d-flex
          justify-content-between
          reg-accordion
          flex-wrap flex-md-nowrap
        "
      >
        <div class="accordion-title mobile-body flex-shrink-0">
          Summer Workshop
        </div>
        <div class="" id="collapse2">
          <!-- <div class="p-2 pt-0 small-text" v-html="regInfo.detail"></div> -->
          <div class="p-2 pt-0 small-text">
            Lecturers and professors from the partner schools/institutions give
            lecture to the 30 best students from the universities all over
            Taiwan who will compete with each other for the one-year scholarship
            in foreign institutions. The purpose of the workshop is to provide
            them the opportunity to acquire some basic skills or knowledge about
            design and to show their potential and talent in design. A final
            score will be given to each student after two weeks of workshop.
          </div>
        </div>
      </div>
      <div
        class="
          d-flex
          justify-content-between
          reg-accordion
          flex-wrap flex-md-nowrap
        "
      >
        <div class="accordion-title mobile-body flex-shrink-0">Finalists</div>
        <div class="" id="collapse3">
          <div class="p-2 pt-0 small-text">
            The committee will officially name the students with the top grades
            as the participants of this project in accordance with the admission
            requirements issued out by the overseas partner schools/institutes.
            Candidates will also be required to take language proficiency test
            in accordance with the partner schools/institutes’ policy.
          </div>
        </div>
      </div>
      <div
        class="
          d-flex
          justify-content-between
          reg-accordion
          flex-wrap flex-md-nowrap
        "
      >
        <div class="accordion-title mobile-body flex-shrink-0">
          Scholarship Winner
        </div>
        <div class="" id="collapse3">
          <div class="p-2 pt-0 small-text">
            The 4 candidates will be sent to the partner institutes for
            admission review. The partner institute is independent in deciding
            the most suitable student to its school.
          </div>
        </div>
      </div>
      <!-- <div class="d-flex justify-content-between reg-accordion d-md-none">
        <div class="accordion-title mobile-body flex-shrink-0">辦理時程</div>
      </div>
      <div class="d-md-none" id="collapse4">
        <div class="small-text schedule-wrap-mobile">
          <div class="d-flex flex-column">
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress1" alt="" class="" /><span class=""
                  >報名</span
                ><span class="title-line flex-grow-1"></span>
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    簡章公告
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p1i1 }}
                  </div>
                </div>
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    報名截止
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p1i2 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress2" alt="" /><span class=""
                  >國內<br />初審</span
                ><span class="title-line flex-grow-1"></span>
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    國內初審名單公告
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p2i1 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress3" alt="" /><span class=""
                  >國內<br />研習</span
                ><span class="title-line flex-grow-1"></span>
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    國內研習營
                  </div>
                  <div class="group-tags">
                    <span class="tag">數位動畫</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p3i1 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">視覺傳達</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[1].p3i1 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">時尚設計</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[2].p3i1 }}
                  </div>
                </div>
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    國內研習營排序公告
                  </div>
                  <div class="group-tags">
                    <span class="tag">數位動畫</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p3i2 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">視覺傳達</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[1].p3i2 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">時尚設計</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[2].p3i2 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress4" alt="" /><span class=""
                  >國內<br />複審</span
                ><span class="title-line flex-grow-1"></span>
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    繳交語言成績及志願表
                  </div>
                  <div class="group-tags">
                    <span class="tag">數位動畫</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p4i1 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">視覺傳達</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[1].p4i1 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">時尚設計</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[2].p4i1 }}
                  </div>
                </div>
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    國內複審合格名單公告
                  </div>
                  <div class="date old-small mobile-small">擇期辦畢公告</div>
                </div>
              </div>
            </div>
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress5" alt="" /><span class=""
                  >海外<br />決選</span
                ><span class="title-line flex-grow-1"></span>
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    海外學校申請
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p5i1 }}
                  </div>
                </div>
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    放榜及正備取通知
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p5i2 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress6" alt="" />出發
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    海外培訓
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p6i1 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </section>
    <div class="n-mx-rem1 mt-5 d-md-none mobile-divider">
      <img :src="divider" alt="" class="w-100" />
    </div>
    <div class="d-none d-lg-block mt-5"></div>
    <!-- Achievement -->
    <div class="mobile-h3 d-md-none text-center mt-3">
      Record of Achievement
    </div>
    <section id="achievement" class="n-mx-rem1 mt-2 mt-md-5">
      <div class="achievement-wrapper">
        <template v-for="(item, i) in recordImages" :key="i">
          <div class="d-inline-flex achievement-unit flex-column">
            <div class="text-justify small-text w-100 d-none d-md-block">
              <template v-if="i + 1 < 10">0</template>{{ i + 1 }}
            </div>
            <div
              class="record-image"
              :style="{ backgroundImage: `url(${recordImages[i]})` }"
            ></div>
          </div>
        </template>
      </div>
      <div class="arrows text-end d-flex justify-content-end">
        <button class="flex-center scroll-btn scroll-left">
          <img :src="arrowLeft" alt="" />
        </button>
        <button class="flex-center scroll-btn scroll-right">
          <img :src="arrowRight" alt="" />
        </button>
      </div>
    </section>
    <!-- institute -->
    <section id="institutes" class="n-mx-rem1 mt-5">
      <div class="n-mx-rem1 mt-5 d-md-none mobile-divider">
        <img :src="divider" alt="" class="w-100" />
      </div>
      <div class="mobile-h3 d-md-none text-center mb-2 mt-3">
        Overseas Partner Institutes (2015-21)
      </div>
      <div class="institutes-wrapper">
        <template
          v-for="(item, i) in institutesByGroup[$route.params.groupId[5] - 1]"
          :key="i"
        >
          <div class="d-inline-flex institutes-unit flex-column">
            <div class="text-justify small-text w-100 d-none d-md-block">
              {{ item.nation }}
            </div>
            <Institute
              :info="item"
              :eng="true"
              class="d-none d-sm-block"
            ></Institute>
            <InstituteM :info="item" :eng="true" class="d-sm-none"></InstituteM>
          </div>
        </template>
      </div>
      <div class="arrows text-end d-flex justify-content-end">
        <button class="flex-center scroll-btn scroll-left">
          <img :src="arrowLeft" alt="" />
        </button>
        <button class="flex-center scroll-btn scroll-right">
          <img :src="arrowRight" alt="" />
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import 'overlayscrollbars/css/OverlayScrollbars.min.css';
import OverlayScrollbars from 'overlayscrollbars/js/OverlayScrollbars.min';

import Institute from '@/components/about/Institute.vue';
import InstituteM from '@/components/about/InstituteM.vue';
// import Feature from '@/components/about/Feature.vue';

import divider from '@/assets/img/divider.svg';
import arrowLeft from '@/assets/img/arrow-left.svg';
import arrowRight from '@/assets/img/arrow-right.svg';
import intro from '@/assets/img/about/intro.jpg';

import r1 from '@/assets/img/about/record1.jpg';
import r2 from '@/assets/img/about/record2.jpg';
import r3 from '@/assets/img/about/record3.jpg';
import r4 from '@/assets/img/about/record4.jpg';
import r5 from '@/assets/img/about/record5.jpg';
import r6 from '@/assets/img/about/record6.jpg';
import r7 from '@/assets/img/about/record7.jpg';
import r8 from '@/assets/img/about/record8.jpg';
import r9 from '@/assets/img/about/record9.jpg';
import r10 from '@/assets/img/about/record10.jpg';
import r11 from '@/assets/img/about/record11.jpg';
import r12 from '@/assets/img/about/record12.jpg';

import progress1 from '@/assets/img/about/progress1.svg';
import progress2 from '@/assets/img/about/progress2.svg';
import progress3 from '@/assets/img/about/progress3.svg';
import progress4 from '@/assets/img/about/progress4.svg';
import progress5 from '@/assets/img/about/progress5.svg';
import progress6 from '@/assets/img/about/progress6.svg';
import applySchedule from '@/assets/img/apply-schedule.png';
import applyScheduleM from '@/assets/img/about/timeline_m.png';

// // api
// import { getInstituteList } from '@/api/institute';
// import { getReg } from '@/api/reg';
// import { getScheduleList } from '@/api/schedule';

export default {
  name: 'AboutEn',
  components: {
    Institute,
    InstituteM,
    // Feature,
  },
  data() {
    return {
      intro,
      progress1,
      progress2,
      progress3,
      progress4,
      progress5,
      progress6,
      recordImages: [r1, r2, r3, r4, r5, r6, r7, r8, r9, r10, r11, r12],
      divider,
      arrowLeft,
      arrowRight,
      applySchedule,
      applyScheduleM,
      ins: [{
        id: 4, title: '普瑞特藝術大學', title_en: 'Pratt Institute', group: 2, quota: 1, expertise: '視覺傳達、包裝設計、設計實務', nation: 'USA', intro: '普瑞特藝術大學於1887年在紐約成立，迄今已有100多年的歷史，是世界許多著名的設計師培育的搖籃。校園集中在布魯克林校區，由於附近即為領導時代流行尖端的紐約市，所接觸到的資訊也是比一般城市來得迅速、完整。該校所提供設計相關的課程眾多，且全球排名皆名列前茅，而其傳達設計系更著重於創意、工具技術的運用，以便幫助學生增進專業技術能力，揮灑最精采的創意構思。該研究所提供包裝設計(MS)跟視覺傳達設計(MFA)兩大學為主軸課程。', image: 'institute_4.jpg', link: '', created_at: '2021-08-15T20:17:03.000Z', updated_at: '2021-09-05T14:57:49.000Z',
      }, {
        id: 2, title: '聖約瑟夫藝術學院 ', title_en: 'AKV｜St.Joost', group: 1, quota: 1, expertise: '動畫實習、動畫藝術、動畫應用', nation: 'the Netherland', intro: '聖約瑟夫藝術學院現為埃文斯應用科技大學(Avans University of Applied Sciences)分校之一，該校創於1812年，作為分校校史悠久，已有200年歷史。因應地理優勢，學校積極鼓勵學生參加當地舉辦的藝術設計節，斯海爾托亨博斯校區前身為荷蘭郵政的分送中心，校區占地廣大，吸引創作者聚集，資源持續擴充，亦將陸續設立媒體博物館或引進各類工作坊。動畫系所為荷蘭第一所開立動畫碩士班的學校，除校園學習外，於本計畫另搭配荷蘭頗負盛名的PostPanic工作室實習，於一年中同時具備學術及業界的經驗。\n', image: 'institute_2.jpg', link: '', created_at: '2021-08-15T20:17:03.000Z', updated_at: '2021-09-05T14:52:22.000Z',
      }, {
        id: 1, title: '高等資訊視覺傳播學院', title_en: 'RUBIKA Valenciennes', group: 1, quota: 1, expertise: '電影特效、動畫實務、動畫電影', nation: 'France', intro: '高等資訊視覺傳播學院於1988年，是歐洲最早結合電腦技術與藝術的學校之一。目前已成為多媒體電腦圖像製作領域的的頂尖學校。近年來，多位高等資訊傳播學院的畢業生都是歐洲動畫的先鋒人物。其課程內容以專業動畫製作學習及小組合作為主，學生加入一年的動畫製作團隊，全程參與近乎專業的動畫製作過程，並佐以專業教師的指導及討論。\n', image: 'institute_1.jpg', link: 'https://www.facebook.com', created_at: '2021-08-15T20:02:58.000Z', updated_at: '2021-09-05T14:51:20.000Z',
      }, {
        id: 3, title: '雪萊頓技術學院', title_en: 'Sheridan College', group: 1, quota: 1, expertise: '動畫短片、電腦動畫、動畫技術', nation: 'Canada', intro: '雪萊頓技術學院是一所加拿大著名的公立高等學院，建立於1967年， 是加拿大目前一流才工藝院校之一。Sheridan學院是動畫設計師的搖籃，有動畫界哈佛的美譽。動畫學院的畢業生曾獲得四次奧斯卡提名，在美國好萊塢供不應求。Sheridan最有名的是動畫設計課程了。因為其教授和學生們製作了鐵達尼號而出名。電影《魔鬼終結者》、《侏羅紀公園》正是雪爾頓學院畢業生Steve Williams的作品。雪爾頓學院的畢業生參與製作動畫和特效的還包括《阿甘正傳》、《星際大戰》、《史瑞克》、《一家之鼠》、《埃及王子》以及製造了票房之最的《魔戒》等人們耳熟能詳的諸多電影。\n', image: 'institute_3.jpg', link: '', created_at: '2021-08-15T20:17:03.000Z', updated_at: '2021-09-05T14:49:49.000Z',
      }, {
        id: 8, title: '皇家墨爾本理工大學', title_en: 'RMIT University', group: 1, quota: 1, expertise: '動畫理論、數位創作、產業實習', nation: 'Australia', intro: '皇家墨爾本理工大學建立於1887年，位於墨爾本市中心，教育理念著重就業導向，與業界有密切的聯繫，並提供教學與實習的配合。該校在動畫領域方面的表現，處於全澳洲的領先地位，在其所提供的動畫課程中，學生可以得到觀念、生產、以及研究性質的多面向學習，課程特色以客戶為焦點，具備創意和實用性。在畢業以前，大多數學生都能獲得實際工作經驗，或參加與相關產業密切相聯的課題研究。皇家墨爾本設計學院的學生們富有創造性、判斷力及責任感，為其所從事的職業做出自己的貢獻。QS World Ranking 近年持續將該校排行為全澳第十名的大學。', image: 'institute_8.jpg', link: '', created_at: '2021-09-05T14:49:03.000Z', updated_at: '2021-09-05T14:49:03.000Z',
      }, {
        id: 9, title: '哥布林視覺學校', title_en: "Gobelins, l'École de l'image", group: 1, quota: 1, expertise: '電影動畫、動畫特效、動畫實務', nation: 'France', intro: 'Gobelins視覺學校座落巴黎市區，創校於1975年，享富國際知名度，除知名動畫《小小兵》Pierre Coffin為該校傑出校友外，多位校友亦受雇於全球性的工作室如迪士尼、環球影業、皮克斯、夢工廠及華納兄弟。近年來，Gobelins致力於多媒體內容發展，著重於網頁、CD、互動DVD以及公共藝術的創新。本計畫與該校合作系所為3D角色動畫系，是跟世界規模最大的法國安錫動畫影展合作辦理，上課地點在安錫城，學員能有享有專業的師資與課程，並擁有極高的就業率。', image: 'institute_9.jpg', link: '', created_at: '2021-09-05T14:49:03.000Z', updated_at: '2021-09-05T14:49:03.000Z',
      }, {
        id: 10, title: '帕森設計學院', title_en: 'Parsons the New School for Design', group: 2, quota: 1, expertise: '視覺傳達、互動媒體、設計思考', nation: 'USA', intro: '帕森設計學院於1896年成立，座落於紐約市 第七大道，1970年與紐約新學院大學(New School)合併，自此開始發展、成長為全美最大的 藝術與設計學校之一，除了享有國際化盛名之外，與本計畫合作的設計與科技研究所，更加視覺傳達設計提升到應用互動科技與視覺化藝術創作的整合新境界。能夠提供學生多元化的專業設計的課程，並讓學生學習到獨自及團體設計上的實務經驗及理念，因而在學術及業界均享有盛名。', image: 'institute_10.jpg', link: '', created_at: '2021-09-05T14:49:03.000Z', updated_at: '2021-09-05T14:49:03.000Z',
      }, {
        id: 11, title: '哥布林視覺學校', title_en: "Gobelins, l'École de l'image", group: 2, quota: 1, expertise: '動態設計、設計實務、傳達設計', nation: 'France', intro: 'Gobelins視覺學校座落巴黎市區，創校於1975年，享富國際知名度，除知名動畫《小小兵》Pierre Coffin為該校傑出校友外，多位校友亦受雇於全球性的工作室如迪士尼、環球影業、皮克斯、夢工廠及華納兄弟。近年來，Gobelins致力於多媒體內容發展，著重於網頁、CD、互動DVD以及公共藝術的創新。本計劃與其動態視覺(Motion Graphics)學程合作，提供學生視傳領域的新世代發展。', image: 'institute_11.jpg', link: '', created_at: '2021-09-05T14:49:03.000Z', updated_at: '2021-09-05T14:49:03.000Z',
      }, {
        id: 12, title: '旋濱科技大學', title_en: 'Swinburne University of Technology', group: 2, quota: 1, expertise: '視覺傳達、設計實務、媒體設計', nation: 'Australia', intro: '澳洲旋濱大學位於墨爾本市區，該校提供的培訓課程著重實務訓練，將結合產業界訓練學生的實務製作以及溝通傳達能力。另外該校的設計學院也位居領先地位，曾培養過多位設計大師，為澳洲設計行業培養人才最大的基地和最受認可的學院。', image: 'institute_12.jpg', link: '', created_at: '2021-09-05T14:49:03.000Z', updated_at: '2021-09-05T14:49:03.000Z',
      }, {
        id: 13, title: '科靈設計學院', title_en: 'Design School Kolding', group: 2, quota: 1, expertise: '設計整合、創新實務、生活設計', nation: 'Denmark', intro: '科靈設計學院創校於1967年，現為丹麥科學與教育部下屬的一個獨立機構。為精緻型大學，學校僅有約380名學生，每年招收約90名學生。與產業緊密聯繫，企業資助學校金額瑜過去5年上升800%，企業合作名單廣泛，其中具全球知名度有B&Q、施華洛世奇、ECCO。', image: 'institute_13.jpg', link: '', created_at: '2021-09-05T14:49:03.000Z', updated_at: '2021-09-05T14:49:03.000Z',
      }, {
        id: 14, title: '帕森設計學院', title_en: 'Parsons the New School for Design', group: 3, quota: 1, expertise: '服裝設計、時尚創意、時尚產業連結', nation: 'USA', intro: '帕森設計學院強調跨領域及跨國際的時尚研究，並獲得「世界四大時裝學校」的美譽，其課程與產業界聯繫密切，擁有多家知名品牌的贊助與產學合作關係。在錄取率異常的嚴謹的要求下，每年入選的學生都能獲得成為國際級的設計新秀的保證。', image: 'institute_14.jpg', link: '', created_at: '2021-09-05T14:49:03.000Z', updated_at: '2021-09-05T14:49:03.000Z',
      }, {
        id: 15, title: '皇家藝術學院', title_en: 'Royal College of Art', group: 3, quota: 1, expertise: '男女服裝設計、織品設計、時尚產業實習', nation: 'UK', intro: '皇家藝術學院在2017 QS世界排名為藝術與設計類第一學府，課程細分為男裝、女裝以及織品設計三類，以師徒制的一對一方式建立學生的個人風格，並提供英國以及歐洲的時尚產業資訊，學習過程中強調跨國的產業實地實習以及個人工作室創作。', image: 'institute_15.jpg', link: '', created_at: '2021-09-05T14:49:03.000Z', updated_at: '2021-09-05T14:49:03.000Z',
      }, {
        id: 5, title: '南加州大學', title_en: 'University of Southern California', group: 1, quota: 1, expertise: '動畫創意、數位藝術、影視製作', nation: 'USA', intro: '成立於洛杉磯的南加州大學，充分利用其地域優勢，打造了位居全美第一的影劇學院。其媒體設計系發展重點在於促進國際化與多元文化之動畫和藝術，並大力鼓勵學生創新和嘗試，強調想像力，創造力和批判性思維。', image: 'institute_5.jpg', link: '', created_at: '2021-08-15T20:17:03.000Z', updated_at: '2021-08-28T12:33:16.000Z',
      }],
      regInfo: null,
      schedule: [],
    };
  },
  computed: {
    institutesByGroup() {
      const rst = [[], [], []];
      this.ins.forEach((ele) => {
        rst[ele.group - 1].push(ele);
      });
      return rst;
    },
    // scheduleByGroup() {
    //   const rst = [[], [], []];
    //   this.schedule.forEach((ele) => {
    //     rst[ele.id - 1] = ele;
    //   });
    //   return rst;
    // },
  },
  methods: {
    getPosition(element) {
      let e = element;
      let x = 0;
      let y = 0;
      while (e) {
        x += e.offsetLeft - e.scrollLeft + e.clientLeft;
        y += e.offsetTop - e.scrollLeft + e.clientTop;
        e = e.offsetParent;
      }
      return { x, y };
    },
    mouseDownHandlerA(e) {
      const ele = document.querySelector('#achievement .os-viewport');
      this.pos = {
        // The current scroll
        left: ele.scrollLeft,
        top: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      };
      ele.style.cursor = 'grabbing';
      ele.style.userSelect = 'none';
      ele.addEventListener('mousemove', this.mouseMoveHandlerA);
      ele.addEventListener('mouseup', this.mouseUpHandlerA);
      ele.addEventListener('mouseleave', this.mouseUpHandlerA);
    },
    mouseMoveHandlerA(e) {
      // How far the mouse has been moved
      const dx = e.clientX - this.pos.x;
      const dy = e.clientY - this.pos.y;

      const ele = document.querySelector('#achievement .os-viewport');
      ele.scroll({ x: this.pos.top - dy, y: this.pos.left - dx }, 500);
      // Scroll the element
      ele.scrollTop = this.pos.top - dy;
      ele.scrollLeft = this.pos.left - dx;
    },
    mouseUpHandlerA() {
      const ele = document.querySelector('#achievement .os-viewport');
      ele.removeEventListener('mousemove', this.mouseMoveHandlerA);
      ele.style.cursor = 'grab';
      ele.style.removeProperty('user-select');
    },
    mouseDownHandlerI(e) {
      const ele = document.querySelector('#institutes .os-viewport');
      this.pos = {
        // The current scroll
        left: ele.scrollLeft,
        top: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      };
      ele.style.cursor = 'grabbing';
      ele.style.userSelect = 'none';
      ele.addEventListener('mousemove', this.mouseMoveHandlerI);
      ele.addEventListener('mouseup', this.mouseUpHandlerI);
      ele.addEventListener('mouseleave', this.mouseUpHandlerI);
    },
    mouseMoveHandlerI(e) {
      // How far the mouse has been moved
      const dx = e.clientX - this.pos.x;
      const dy = e.clientY - this.pos.y;

      const ele = document.querySelector('#institutes .os-viewport');
      ele.scroll({ x: this.pos.top - dy, y: this.pos.left - dx }, 500);
      // Scroll the element
      ele.scrollTop = this.pos.top - dy;
      ele.scrollLeft = this.pos.left - dx;
    },
    mouseUpHandlerI() {
      const ele = document.querySelector('#institutes .os-viewport');
      ele.removeEventListener('mousemove', this.mouseMoveHandlerI);
      ele.style.cursor = 'grab';
      ele.style.removeProperty('user-select');
    },
    sideMenuOnScroll() {
      // const homeBannerHeight = (document.getElementById('home-banner')) ? document.getElementById('home-banner').offsetHeight : 0;
      // const bannerHeight = homeBannerHeight + document.getElementById('main-nav').offsetHeight;
      // this.isFixed = window.scrollY > 0;

      const descPos = this.getPosition(document.getElementById('desc'));
      const schePos = this.getPosition(document.getElementById('schedule'));
      const achievePos = this.getPosition(document.getElementById('achievement'));
      // const insPos = this.getPosition(document.getElementById('institutes'));
      const scrollLength = document.body.scrollHeight - window.innerHeight;

      if (window.scrollY >= scrollLength - 50) {
        this.$emit('setCurSection', 'Overseas Partner Institutes');
      } else
      if (window.scrollY >= scrollLength * ((achievePos.y - 200) / document.body.scrollHeight)) {
        this.$emit('setCurSection', 'Record of Achievement');
      } else if (window.scrollY >= scrollLength * ((schePos.y - 200) / document.body.scrollHeight)) {
        this.$emit('setCurSection', 'Selection Process');
      } else if (window.scrollY >= scrollLength * ((descPos.y - 200) / document.body.scrollHeight)) {
        this.$emit('setCurSection', 'Introduction');
      }

      // if ((scrollLength - window.scrollY < 200 && window.scrollY + 200 > achievePos.y + document.getElementById('achievement').offsetHeight / 2) || document.body.scrollHeight - window.innerHeight - window.scrollY < 10) {
      //   this.curSection = 'Overseas Partner Institutes';
      //   this.$emit('setCurSection', 'Overseas Partner Institutes');
      // } else if (window.scrollY + 200 >= achievePos.y) {
      //   this.curSection = 'Record of Achievement';
      //   this.$emit('setCurSection', 'Record of Achievement');
      // } else if (window.scrollY + 200 >= schePos.y) {
      //   this.curSection = 'Selection Process';
      //   this.$emit('setCurSection', 'Selection Process');
      // } else {
      //   this.curSection = 'Introduction';
      //   this.$emit('setCurSection', 'Introduction');
      // }
    },
  },
  created() {
    // const filter = { order: 'updated_at desc' };
    // getInstituteList({ filter }).then((response) => {
    //   this.ins = response;
    // });
    // getReg().then((response) => {
    //   this.regInfo = response;
    // });
    // getScheduleList().then((response) => {
    //   this.schedule = response;
    // });
  },
  mounted() {
    this.sideMenuOnScroll();
    window.addEventListener('scroll', this.sideMenuOnScroll);
    const cxt = this;
    setTimeout(() => {
      const settings = {
        className: 'os-theme-dark',
        sizeAutoCapable: true,
        paddingAbsolute: true,
        overflowBehavior: {
          x: 'scroll',
          y: 'hidden',
        },
        scrollbars: {
          clickScrolling: true,
          visibility: 'auto',
        },
        callbacks: {},
      };
      settings.callbacks.onInitialized = () => document.querySelector('#achievement .os-viewport').addEventListener('mousedown', cxt.mouseDownHandlerA);
      settings.callbacks.onScroll = function () {
        if (this.scroll().position.x === 0) {
          document.getElementById('achievement').classList.remove('left-fade');
        } else {
          document.getElementById('achievement').classList.add('left-fade');
        }
      };
      const aScroll = OverlayScrollbars(document.querySelector('.achievement-wrapper'), settings);

      document.querySelector('#achievement .scroll-left').addEventListener('click', () => aScroll.scroll({ x: '-= 200px' }));
      document.querySelector('#achievement .scroll-right').addEventListener('click', () => aScroll.scroll({ x: '+= 200px' }));

      settings.callbacks.onInitialized = () => document.querySelector('#institutes .os-viewport').addEventListener('mousedown', cxt.mouseDownHandlerI);
      settings.callbacks.onScroll = function () {
        if (this.scroll().position.x === 0) {
          document.getElementById('institutes').classList.remove('left-fade');
        } else {
          document.getElementById('institutes').classList.add('left-fade');
        }
      };
      const iScroll = OverlayScrollbars(document.querySelector('.institutes-wrapper'), settings);

      document.querySelector('#institutes .scroll-left').addEventListener('click', () => iScroll.scroll({ x: '-= 200px' }));
      document.querySelector('#institutes .scroll-right').addEventListener('click', () => iScroll.scroll({ x: '+= 200px' }));

      const sScroll = OverlayScrollbars(document.querySelector('.schedule-wrap'), {
        className: 'os-theme-dark',
        sizeAutoCapable: true,
        paddingAbsolute: true,
        scrollbars: {
          clickScrolling: true,
        },
      });

      document.querySelector('#schedule .scroll-left').addEventListener('click', () => sScroll.scroll({ x: '-= 200px' }));
      document.querySelector('#schedule .scroll-right').addEventListener('click', () => sScroll.scroll({ x: '+= 200px' }));
    }, 50);

    // side menu click event
    const menuItems = document.querySelectorAll('.lv1 a');
    menuItems.forEach((mi) => mi.addEventListener('click', (e) => {
      const yOffset = -170;
      const element = document.querySelector(e.target.getAttribute('href'));
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }));
  },
  unmounted() {
    window.removeEventListener('scroll', this.sideMenuOnScroll);
  },
};
</script>

<style lang="stylus" scoped>
section + section
  margin-top: 96px;

.about-wrap + .about-wrap
  margin-top: 96px;

.about-img
  width: 55%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 360px;

.about-text
  width: 45%;
  min-width: 45%;

.institute-block, .feature-block
  cursor: grab;

@media screen and (min-width: 991px)
  .about-text
    &.first
      padding-left: 36px !important;

    &.second
      padding-right: 36px !important;

.reg-accordion
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: 1px solid $monoc4;

.accordion-title
  width: 200px;
  font-weight: bold;
  font-size: 20px;
  line-height: 150%;

.btn-trigger
  &:focus, &:hover, &:active
    box-shadow: none;

  .plus
    display: block;

  .minus
    display: none;

  &:not(.collapsed)
    .minus
      display: block;

    .plus
      display: none;

#schedule
  position: relative;

  .schedule-wrap
    white-space: nowrap;
    padding-bottom: 12px;

  .schedule-phase
    flex: 1 0 auto;

  .schedule-phase + .schedule-phase
    padding-left: 36px;
    margin-bottom: 16px;

  .phase-title
    flex-basis: 50px;
    margin-bottom: 16px;
    white-space: normal;

    img
      width: 24px;
      height: 24px;
      margin-right: 4px;

  .title-line
    height: 0.6em;
    border-bottom: solid 1px $monoc4;
    margin-left: 4px;

  .phase-content + .phase-content
    margin-top: 16px;

.schedule-wrap-mobile
  border: 1px solid #BCB8B1;
  border-radius: 20px;
  padding: 20px 0;

  .schedule-phase + .schedule-phase
    .phase-title, .phase-content-wrap
      padding-top: 20px;

  .phase-title
    width: 80px;
    align-items: center;

    // padding: 0 20px;
    img
      width: 36px;
      height: 36px;
      margin-bottom: 4px;

  .phase-content-wrap
    border-left: 1px solid $monoc4;
    padding-left: 20px;

  .phase-content + .phase-content
    margin-top: 20px;

  .group-tags
    margin: 6px 0;

    .tag
      border: 1px solid $monoc4;
      border-radius: 20px;
      font-size: 11px;
      padding: 4px 6px;

    .tag + .tag
      margin-left: 6px;

@media screen and (max-width: 1200px)
  .title-line
    width: 30px;

#achievement, #institutes
  position: relative;

.achievement-wrapper, .institutes-wrapper
  padding-bottom: 30px;
  white-space: nowrap;
  cursor: grab;

.achievement-wrapper
  height: 350px;

.record-image
  width: 420px;
  height: calc((420px * 3 / 4));
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

.achievement-unit
  width: 420px;
  height: calc((420px * 3 / 4));
  overflow: hidden;
  white-space: normal;

.institutes-unit
  width: 360px;
  white-space: normal;

// @media screen and (min-width: 768px)
// .achievement-unit
// height: 460px;
@media screen and (min-width: 576px)
  .institutes-unit
    width: 360px;
    height: 460px;
    overflow: hidden;

@media screen and (max-width: 767.5px)
  #achievement
    // height: 625px;
    .achievement-wrapper, .achievement-unit
      height: 100% !important;

  .achievement-wrapper
    padding-bottom: 24px;

    .record-image
      width: 100%;

  .institutes-wrapper
    padding-bottom: 16px;

  section + section
    margin-top: 0;

  .about-text, .about-img
    width: 100%;
    // min-width: 100%;

  .about-img
    margin-bottom: 24px;

  .about-text
    &.first, &.second
      padding: 0;

#achievement, #institutes, .mobile-divider
  width: 100% !important;

@media screen and (min-width: 768px)
  #achievement, #institutes
    &:after, &.left-fade:before
      content: '';
      position: absolute;
      z-index: 1;
      bottom: 30px;
      pointer-events: none;
      background-image: linear-gradient(to right, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);
      width: 50px;
      height: 100%;

    &:after
      right: -15px;
      background-image: linear-gradient(to right, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);

    &.left-fade:before
      left: -15px;
      background-image: linear-gradient(to left, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);

@media screen and (max-width: 575.7px)
  .achievement-unit, .institutes-unit
    width: 100%;

@media screen and (max-width: 1000.5px)
  #institutes
    margin-bottom: 70px;
</style>

<style lang="stylus">
.os-scrollbar-track
  background-color: $monoc2 !important;

.os-scrollbar-handle
  background-color: $monoc4 !important;

.os-host-scrollbar-horizontal-hidden + .arrows
  display: none !important;
</style>
